"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestReservationConfirmation = void 0;
var GuestReservationConfirmation;
(function (GuestReservationConfirmation) {
    GuestReservationConfirmation["successful"] = "successful";
    GuestReservationConfirmation["realTime"] = "realTime";
    GuestReservationConfirmation["noFreeTables"] = "noFreeTables";
    GuestReservationConfirmation["requestSent"] = "requestSent";
    GuestReservationConfirmation["invalidDate"] = "invalidDate";
    GuestReservationConfirmation["invalidGuestNumber"] = "invalidGuestNumber";
    GuestReservationConfirmation["failed"] = "failed";
})(GuestReservationConfirmation || (exports.GuestReservationConfirmation = GuestReservationConfirmation = {}));
//# sourceMappingURL=GuestReservationConfirmation.js.map